import React from "react";
import { Link } from "react-router-dom";
import { navSections, partnerNames } from "../../data/site";
export function SiteFooter() {
  return <footer className="bg-sun pt-20 text-ink" data-id="element-635" data-mp="2tmq0a8f4amyr">
      <div className="mx-auto max-w-[1400px] px-5 md:px-8" data-id="element-636" data-mp="2omap9nib5rjy">
        <div className="grid gap-10 md:grid-cols-[1fr_auto]" data-id="element-637" data-mp="2oowwtn578726">
          <div data-id="element-638" data-mp="2kkgshqb8h7p2">
            <p className="text-[12px] font-bold uppercase tracking-wide" data-id="element-639" data-mp="2kkpa1viax16l">In partnership with</p>
            <ul className="mt-3 space-y-1" data-id="element-640" data-mp="2fnqd75796g4p">
              {partnerNames.map(p => <li key={p} className="font-display text-3xl uppercase md:text-4xl" data-id="element-641" data-mp="2auniuuunj2ng">
                  {p}
                </li>)}
            </ul>
          </div>
          <nav aria-label="Footer" className="flex flex-wrap gap-2 self-end" data-id="element-642" data-mp="20y0xm4yey9kw">
            {navSections.map(s => <a key={s.id} href={`#${s.id}`} className="rounded-full border border-ink px-4 py-2 text-[12px] font-semibold uppercase tracking-wide transition-colors duration-150 hover:bg-ink hover:text-sun" data-id="element-643" data-mp="1wucq1m9s7dzn">
                {s.label}
              </a>)}
          </nav>
        </div>
        <p className="mt-16 select-none text-center font-display text-[clamp(4rem,17vw,16rem)] uppercase leading-[0.8]" aria-hidden="true" data-id="element-644" data-mp="2q91x8npyimoh">
          Hackathon
        </p>
        <div className="flex flex-wrap items-center justify-between gap-3 border-t border-ink/25 py-5 text-[12px] font-semibold uppercase tracking-wide" data-id="element-645" data-mp="2u8aqlrh34iji">
          <span data-id="element-646" data-mp="3mzatfz3ojg9l">Vibe Engineering Hackathon · October 2026</span>
          <Link to="/organizer" className="hover:underline" data-id="element-647" data-mp="38z9u4o32cgw8">
            Organizer dashboard
          </Link>
        </div>
      </div>
    </footer>;
}